<template>
  <div class="text-field-wrapper no-v-short-key">
    <!--    :class="{ 'text-field-wrapper--disabled': $attrs.disabled }"-->
    <div
      :class="[
        'text-field',
        $attrs['parent-class'],
        size,
        bgColor,
        borderColor,
        {
          active: !!value || value === 0,
          focus: isFocus,
          'has-error': hasError
        }
      ]"
    >
      <input
        :class="['md:px-4 px-2 text-field-input', $attrs['input-class'], hasShortKey]"
        :type="type"
        :value="value"
        v-bind="excludeAttrs"
        :maxlength="maxLength"
        @focus="emitFocus"
        @blur="emitBlur"
        v-on="$listeners"
        @input="setValue($event.target.value)"
      >
      <label
        v-if="label"
        class="text-field-label"
        :class="labelColor"
      >
        {{ label }}
      </label>
      <label
        v-if="placeholder"
        class="text-field-placeholder"
        :class="labelColor"
      >
        {{ placeholder }}
      </label>
      <div class="text-field-icon icon-left">
        <slot name="icon-left" />
      </div>
      <transition name="fade">
        <ProgressLiner
          v-if="loading"
          class="inset-x-0 bottom-0 w-auto"
        />
      </transition>
    </div>
    <span
      v-if="!isHiddenError && (serverError || error)"
      class="text-field-error"
    >
      <template v-if="!serverError && error">
        {{ $t(`forms.${$attrs.name}.errors.${error}`) }}
      </template>
      <template v-if="serverError">
        {{ serverError }}
      </template>
    </span>
    <div
      v-if="helper"
      class="text-field-helper"
      v-html="helper"
    />
  </div>
</template>

<script>

import ProgressLiner from '@library/ui/loading/progress-liner'
const TYPES = ['text', 'password', 'email', 'number', 'url', 'tel', 'search', 'color']
const includes = types => type => types.includes(type)

export default {
  name: 'AppInput',
  components: { ProgressLiner },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    helper: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    maxLength: {
      type: [String, Number],
      default: ''
    },
    error: {
      type: String,
      default: null
    },
    serverError: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text',
      validator (value) {
        return includes(TYPES)(value)
      }
    },
    checkNumber: {
      type: Boolean,
      default: true
    },
    isShortKey: {
      type: Boolean,
      default: false
    },
    isHiddenError: {
      type: Boolean,
      default: false
    },
    xmoney: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: 'bg-white'
    },
    labelColor: {
      type: String,
      default: 'text-gray-medium'
    },
    borderColor: {
      type: String,
      default: 'border-gray-light'
    }
  },
  data () {
    return {
      isFocus: false
    }
  },
  computed: {
    hasShortKey () {
      return !this.isShortKey ? 'no-v-short-key' : ''
    },
    hasError () {
      return !!(this.error || this.serverError)
    },
    excludeAttrs () {
      const attr = { ...this.$attrs }
      delete attr['input-class']
      return attr
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: 'setUpdateValue'
    }
  },
  mounted () {
    if (this.autoFocus) {
      this.focus()
    }
  },

  methods: {
    emitFocus () {
      this.isFocus = true
      this.$emit('emitFocus')
      this.$store.commit('SET_STATE_BTN_CALL', true)
    },
    emitBlur () {
      this.isFocus = false
      this.$emit('emitBlur')
      this.$store.commit('SET_STATE_BTN_CALL', false)
    },
    setUpdateValue (value) {
      if (value !== '') {
        this.$emit('update', value)
      }
    },
    setValue (value) {
      this.$emit('update', value)
    },
    focus () {
      // TODO check this part in the next time
      /* window.setTimeout(() => {
        document.querySelector(`input[name=${this.$attrs.name}]`).focus()
      }, 0) */
      this.isFocus = true
    },
    unFocus () {
      const thisInput = document.querySelector(`input[name=${this.$attrs.name}]`)
      thisInput.blur()
      this.isFocus = false
    }
  }
}
</script>

<style lang="scss" scoped>
.text-field {
  @apply w-full relative flex items-center rounded border;
  transition: height 0.2s ease-in-out;
  .vue-fixed-header--isFixed & {
    height: 36px !important;
  }
    &.xl {
      @apply h-9 lg:h-[58px];
    }
    &.lg-fixed {
      @apply h-14 lg:h-14;
    }
    &.lg {
      @apply h-9 lg:h-14;
    }
    &.md {
      @apply h-9 lg:h-12;
    }
    &.sm {
      @apply h-9 lg:h-[38px];
    }
    &.xs {
      @apply h-9;
    }
  &.focus {
    @apply border-blue-primary;
  }
  &.has-error,
  &.has-error.focus {
    @apply border-red-500;
  }
  &.active {
    .text-field {
      &-label {
        @apply -top-5 -right-4 translate-y-0 text-xs-xs;
      }
      &-placeholder{
        @apply hidden;
      }
    }
  }
  /*  &-wrapper {
    &--disabled {
      @apply bg-gray-light;
    }
  }*/
  &-input {
    @apply h-full rounded w-full border-none focus:outline-none  text-gray-main text-xs xs:text-sm md:text-sm;
    &__wrapper {
      @apply flex items-center;
    }
    &[readonly]:not([disabled])  {
      @apply cursor-pointer;
    }
    &[disabled]  {
      @apply cursor-not-allowed;
    }
    /*      &[disabled] {
      @apply bg-white;
      + {
        .text-field-label {
          @apply text-gray-light;
        }
      }
    }*/
  }
  &-error {
    @apply text-red-500 text-xs py-1 px-1 font-normal pb-4 block;
  }
  &-label {
    @apply absolute top-1/2 transform -translate-y-1/2 pr-4  text__sub--3 md:text__sub--1 pointer-events-none transition-all;
  }
  &-placeholder {
    @apply absolute top-1/2 transform -translate-y-1/2 pr-4  text__sub--3 md:text__sub--1 pointer-events-none transition-all;
  }
  &-helper {
    @apply text-xs px-1 py-1 font-normal;
    color: theme('colors.gray.medium');
  }
}
.text-field-input.text-gray-light {
  color: theme('colors.gray.light');
}
.text-field-input.text-gray-medium {
  color: theme('colors.gray.medium');
}

.text-field-placeholder-pr-5{
  .text-field-placeholder {
    @apply pr-12;
  }
}

.md > .text-field-placeholder{
  @apply text__sub--3 md:text__sub--1;
  @apply font-medium;
}

.md > .text-field-input{
  @apply text__sub--3 md:text__sub--1;
  // @apply font-medium;
}

</style>
